module.exports = __webpack_public_path__ + "img/message-smile-square.960b0d20.svg";